






import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

import Assets from '@/constants/assets';

@Component({
  components: {
  },
})
export default class Spinner extends Vue {
  @Prop( { default: 1000 } ) private minimumTimeToShow!: number;
  @Prop( { default: 0 } ) private lastTimeShowWasRequested!: number;
  @Prop( { default: false } ) private hideRequested!: boolean;

  private assets = Assets;

  @Watch('lastTimeShowWasRequested')
  private watchLastTimeShowWasRequested(newVal: any, oldVal: any) {
    window.setTimeout(() => {
      const now = new Date().getTime();
      if ( !this.hideRequested && now - this.lastTimeShowWasRequested > this.minimumTimeToShow ) {
        this.emitShow();
      }
    }, this.minimumTimeToShow);
  }

  private emitShow() {
    this.$emit( 'spinner-show' );
  }

}
